module.exports = __webpack_public_path__ + "img/pic13.9dc52b90.png";